import { IntegrationUpsert } from 'models/integrations'
import api from '..'
import { integrationTypesByKeys } from '../../models/integrations'


export const upsertIntegration = ({
  integrationType: type,
  ...data
}: IntegrationUpsert) => {
  const key = integrationTypesByKeys[type]
  return api.put(`integrations/${key}`, data)
}

export default upsertIntegration
